/**
 * User-facing name for a curated grouping of resources (list, hub layout, or landing).
 * Flip GROUPING_BRAND to 'collection' if reviewers prefer Collection.
 * Storage and /api/hubs use Hub. /toolkits redirects to /hubs.
 */
export type GroupingBrand = 'hub' | 'collection';

export const GROUPING_BRAND: GroupingBrand = 'hub';

const COPY = {
  hub: {
    singular: 'Hub',
    plural: 'Hubs',
    singularLower: 'hub',
    pluralLower: 'hubs',
    indexPath: '/hubs',
    indexBlurb:
      'Grouped resources for a practice area or task — documents, tools, and guidance in one place.',
  },
  collection: {
    singular: 'Collection',
    plural: 'Collections',
    singularLower: 'collection',
    pluralLower: 'collections',
    indexPath: '/collections',
    indexBlurb:
      'Curated collections of resources organized by topic or purpose.',
  },
} as const;

export const GROUPING = COPY[GROUPING_BRAND];

export function groupingHref(slug?: string | null): string {
  return slug ? `${GROUPING.indexPath}/${slug}` : GROUPING.indexPath;
}
